<template>
  <router-view class="" name="header"></router-view>
  <router-view/>
  <router-view class="" name="footer"></router-view>
  <router-view class="" name="stickybottommobile"></router-view>
  <router-view class="" name="panelcompte"></router-view>
</template>
